import actions from "@/store/modules/spot/actions";
import mutations from "@/store/modules/spot/mutations";
import state from "@/store/modules/spot/state";

export default {
    actions,
    mutations,
    state
}